import state from './server.state'
import mutations from './server.mutations'
import actions from './server.actions'

export default {
  state,
  mutations,
  actions
}
